import {
  Backdrop,
  CircularProgress,
  Modal,
  Popper,
  Portal,
} from "@mui/material";
import { usePortal } from "../../../hooks/store";

export default function LoadingPortal({ children }) {
  const { open, RootElementId, setPortal, closePortal } = usePortal();

  return (
    <>
      {children}

      <Backdrop
        sx={(theme) => ({
          backgroundColor: "transparent",
          color: "#fff",
          zIndex: theme.zIndex.drawer + 1,
        })}
        open={open}>
        <CircularProgress
          sx={{
            width: "50px !important",
            height: "50px !important",
            color: "var(--bckg-accent) !important",
          }}
        />
      </Backdrop>
    </>
  );
}
